// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  ApiApplicationListData,
  ApiApplicationListResponse,
  ApiApplicationCreateData,
  ApiApplicationCreateResponse,
  ApiApplicationRetrieveData,
  ApiApplicationRetrieveResponse,
  ApiApplicationUpdateData,
  ApiApplicationUpdateResponse,
  ApiApplicationPartialUpdateData,
  ApiApplicationPartialUpdateResponse,
  ApiApplicationDestroyData,
  ApiApplicationDestroyResponse,
  ApiAwardListData,
  ApiAwardListResponse,
  ApiAwardCreateData,
  ApiAwardCreateResponse,
  ApiAwardRetrieveData,
  ApiAwardRetrieveResponse,
  ApiAwardUpdateData,
  ApiAwardUpdateResponse,
  ApiAwardPartialUpdateData,
  ApiAwardPartialUpdateResponse,
  ApiAwardDestroyData,
  ApiAwardDestroyResponse,
  ApiCandidatePreferencesRetrieveResponse,
  ApiCandidatePreferencesUpdateData,
  ApiCandidatePreferencesUpdateResponse,
  ApiCertificationListData,
  ApiCertificationListResponse,
  ApiCertificationCreateData,
  ApiCertificationCreateResponse,
  ApiCertificationRetrieveData,
  ApiCertificationRetrieveResponse,
  ApiCertificationUpdateData,
  ApiCertificationUpdateResponse,
  ApiCertificationPartialUpdateData,
  ApiCertificationPartialUpdateResponse,
  ApiCertificationDestroyData,
  ApiCertificationDestroyResponse,
  ApiChangelogListData,
  ApiChangelogListResponse,
  ApiChangelogRetrieveData,
  ApiChangelogRetrieveResponse,
  ApiCompanyListData,
  ApiCompanyListResponse,
  ApiCompanyCreateData,
  ApiCompanyCreateResponse,
  ApiCompanyRetrieveData,
  ApiCompanyRetrieveResponse,
  ApiCompanyUpdateData,
  ApiCompanyUpdateResponse,
  ApiCompanyPartialUpdateData,
  ApiCompanyPartialUpdateResponse,
  ApiCompanyDestroyData,
  ApiCompanyDestroyResponse,
  ApiEducationListData,
  ApiEducationListResponse,
  ApiEducationCreateData,
  ApiEducationCreateResponse,
  ApiEducationRetrieveData,
  ApiEducationRetrieveResponse,
  ApiEducationUpdateData,
  ApiEducationUpdateResponse,
  ApiEducationPartialUpdateData,
  ApiEducationPartialUpdateResponse,
  ApiEducationDestroyData,
  ApiEducationDestroyResponse,
  ApiEventsListData,
  ApiEventsListResponse,
  ApiEventsCreateData,
  ApiEventsCreateResponse,
  ApiEventsRetrieveData,
  ApiEventsRetrieveResponse,
  ApiEventsUpdateData,
  ApiEventsUpdateResponse,
  ApiEventsPartialUpdateData,
  ApiEventsPartialUpdateResponse,
  ApiEventsDestroyData,
  ApiEventsDestroyResponse,
  ApiEventsIncrementParticipantsCreateData,
  ApiEventsIncrementParticipantsCreateResponse,
  ApiEventsTodayRetrieveResponse,
  ApiEventsUpcomingRetrieveResponse,
  ApiExperienceListData,
  ApiExperienceListResponse,
  ApiExperienceCreateData,
  ApiExperienceCreateResponse,
  ApiExperienceRetrieveData,
  ApiExperienceRetrieveResponse,
  ApiExperienceUpdateData,
  ApiExperienceUpdateResponse,
  ApiExperiencePartialUpdateData,
  ApiExperiencePartialUpdateResponse,
  ApiExperienceDestroyData,
  ApiExperienceDestroyResponse,
  ApiGoogleloginCreateData,
  ApiGoogleloginCreateResponse,
  ApiJobSkillMatricesListData,
  ApiJobSkillMatricesListResponse,
  ApiJobSkillMatricesCreateData,
  ApiJobSkillMatricesCreateResponse,
  ApiJobSkillMatricesRetrieveData,
  ApiJobSkillMatricesRetrieveResponse,
  ApiJobSkillMatricesUpdateData,
  ApiJobSkillMatricesUpdateResponse,
  ApiJobSkillMatricesPartialUpdateData,
  ApiJobSkillMatricesPartialUpdateResponse,
  ApiJobSkillMatricesDestroyData,
  ApiJobSkillMatricesDestroyResponse,
  ApiJobSkillMatricesUpdateSkillCreateData,
  ApiJobSkillMatricesUpdateSkillCreateResponse,
  ApiJobprofileListData,
  ApiJobprofileListResponse,
  ApiJobprofileCreateData,
  ApiJobprofileCreateResponse,
  ApiJobprofileRetrieveData,
  ApiJobprofileRetrieveResponse,
  ApiJobprofileUpdateData,
  ApiJobprofileUpdateResponse,
  ApiJobprofilePartialUpdateData,
  ApiJobprofilePartialUpdateResponse,
  ApiJobprofileDestroyData,
  ApiJobprofileDestroyResponse,
  ApiLeagueCommissionerRetrieveResponse,
  ApiLeagueCommissionerLedgerCreateResponse,
  ApiLeagueCommissionerRosterCreateResponse,
  ApiLeagueCommissionerTimelineCreateResponse,
  ApiLeagueFreeAgentsRetrieveResponse,
  ApiLeagueFreeAgentsMeRetrieveResponse,
  ApiLeagueFreeAgentsMeUpdateResponse,
  ApiLeagueJudgingRetrieveResponse,
  ApiLeagueJudgingCreateResponse,
  ApiLeagueJudgingFinalizeCreateResponse,
  ApiLeagueLeaderboardRetrieveResponse,
  ApiLeagueLeaderboardChaptersListData,
  ApiLeagueLeaderboardChaptersListResponse,
  ApiLeagueLeaderboardDevelopersListData,
  ApiLeagueLeaderboardDevelopersListResponse,
  ApiLeagueLeaderboardTeamsListData,
  ApiLeagueLeaderboardTeamsListResponse,
  ApiLeagueModeRetrieveResponse,
  ApiLeagueModeSwitchCreateResponse,
  ApiLeagueMyChallengesRetrieveResponse,
  ApiLeagueMyScoreRetrieveResponse,
  ApiLeagueNotificationsRetrieveResponse,
  ApiLeagueNotificationsReadAllCreateResponse,
  ApiLeagueOrganizerRetrieveResponse,
  ApiLeaguePhasesRetrieveData,
  ApiLeaguePhasesRetrieveResponse,
  ApiLeaguePhasesBracketCreateData,
  ApiLeaguePhasesBracketCreateResponse,
  ApiLeaguePhasesFreezeCreateData,
  ApiLeaguePhasesFreezeCreateResponse,
  ApiLeagueRecruitRetrieveResponse,
  ApiLeagueRecruitCoMembershipCreateResponse,
  ApiLeagueRosterInvitesRetrieveResponse,
  ApiLeagueRosterInvitesCreateResponse,
  ApiLeagueRosterInvitesApproveCreateData,
  ApiLeagueRosterInvitesApproveCreateResponse,
  ApiLeagueRosterInvitesConfirmCreateData,
  ApiLeagueRosterInvitesConfirmCreateResponse,
  ApiLeagueRosterInvitesDeclineCreateData,
  ApiLeagueRosterInvitesDeclineCreateResponse,
  ApiLeagueRosterInvitesLockCreateData,
  ApiLeagueRosterInvitesLockCreateResponse,
  ApiLeagueSeasonsRetrieveResponse,
  ApiLeagueSeasonsRetrieve2Data,
  ApiLeagueSeasonsRetrieve2Response,
  ApiLeagueSoloTeamCreateResponse,
  ApiLeagueSubmissionsListResponse,
  ApiLeagueSubmissionsCreateData,
  ApiLeagueSubmissionsCreateResponse,
  ApiLeagueSubmissionsRetrieveData,
  ApiLeagueSubmissionsRetrieveResponse,
  ApiLeagueSubmissionsUpdateData,
  ApiLeagueSubmissionsUpdateResponse,
  ApiLeagueSubmissionsPartialUpdateData,
  ApiLeagueSubmissionsPartialUpdateResponse,
  ApiLeagueSubmissionsDestroyData,
  ApiLeagueSubmissionsDestroyResponse,
  ApiLeagueSubmissionsLockCreateData,
  ApiLeagueSubmissionsLockCreateResponse,
  ApiLeagueSubmissionsValidateCreateData,
  ApiLeagueSubmissionsValidateCreateResponse,
  ApiLeagueSubmissionsOptionsRetrieveResponse,
  ApiLeagueTeamMatchesRetrieveData,
  ApiLeagueTeamMatchesRetrieveResponse,
  ApiLoginCreateData,
  ApiLoginCreateResponse,
  ApiLogoutCreateResponse,
  ApiMatchResultsListData,
  ApiMatchResultsListResponse,
  ApiMatchResultsRetrieveData,
  ApiMatchResultsRetrieveResponse,
  ApiMatchResultsUpdateData,
  ApiMatchResultsUpdateResponse,
  ApiMatchResultsPartialUpdateData,
  ApiMatchResultsPartialUpdateResponse,
  ApiMatchResultsSaveJobCreateData,
  ApiMatchResultsSaveJobCreateResponse,
  ApiMatchingSessionsListData,
  ApiMatchingSessionsListResponse,
  ApiMatchingSessionsRetrieveData,
  ApiMatchingSessionsRetrieveResponse,
  ApiMatchingSkillsListData,
  ApiMatchingSkillsListResponse,
  ApiMatchingSkillsRetrieveData,
  ApiMatchingSkillsRetrieveResponse,
  ApiMatchingSkillsAutocompleteRetrieveResponse,
  ApiMatchingAnalyticsRetrieveResponse,
  ApiMatchingExtractSkillsCreateData,
  ApiMatchingExtractSkillsCreateResponse,
  ApiMatchingMatchRetrieveResponse,
  ApiMatchingMatchCreateData,
  ApiMatchingMatchCreateResponse,
  ApiMatchingTaskStatusRetrieveResponse,
  ApiNonprofitProfileListData,
  ApiNonprofitProfileListResponse,
  ApiNonprofitProfileCreateData,
  ApiNonprofitProfileCreateResponse,
  ApiNonprofitProfileRetrieveData,
  ApiNonprofitProfileRetrieveResponse,
  ApiNonprofitProfileUpdateData,
  ApiNonprofitProfileUpdateResponse,
  ApiNonprofitProfilePartialUpdateData,
  ApiNonprofitProfilePartialUpdateResponse,
  ApiNonprofitProfileDestroyData,
  ApiNonprofitProfileDestroyResponse,
  ApiProfileListData,
  ApiProfileListResponse,
  ApiProfileCreateData,
  ApiProfileCreateResponse,
  ApiProfileRetrieveData,
  ApiProfileRetrieveResponse,
  ApiProfileUpdateData,
  ApiProfileUpdateResponse,
  ApiProfilePartialUpdateData,
  ApiProfilePartialUpdateResponse,
  ApiProfileDestroyData,
  ApiProfileDestroyResponse,
  ApiProjectListData,
  ApiProjectListResponse,
  ApiProjectCreateData,
  ApiProjectCreateResponse,
  ApiProjectRetrieveData,
  ApiProjectRetrieveResponse,
  ApiProjectUpdateData,
  ApiProjectUpdateResponse,
  ApiProjectPartialUpdateData,
  ApiProjectPartialUpdateResponse,
  ApiProjectDestroyData,
  ApiProjectDestroyResponse,
  ApiPublicationListData,
  ApiPublicationListResponse,
  ApiPublicationCreateData,
  ApiPublicationCreateResponse,
  ApiPublicationRetrieveData,
  ApiPublicationRetrieveResponse,
  ApiPublicationUpdateData,
  ApiPublicationUpdateResponse,
  ApiPublicationPartialUpdateData,
  ApiPublicationPartialUpdateResponse,
  ApiPublicationDestroyData,
  ApiPublicationDestroyResponse,
  ApiResourcesListData,
  ApiResourcesListResponse,
  ApiResourcesCreateData,
  ApiResourcesCreateResponse,
  ApiResourcesRetrieveData,
  ApiResourcesRetrieveResponse,
  ApiResourcesUpdateData,
  ApiResourcesUpdateResponse,
  ApiResourcesPartialUpdateData,
  ApiResourcesPartialUpdateResponse,
  ApiResourcesDestroyData,
  ApiResourcesDestroyResponse,
  ApiResourcesIncrementDownloadsCreateData,
  ApiResourcesIncrementDownloadsCreateResponse,
  ApiResourcesIncrementViewsCreateData,
  ApiResourcesIncrementViewsCreateResponse,
  ApiResourcesFreeRetrieveResponse,
  ApiResourcesPopularRetrieveResponse,
  ApiRestRestCheckRetrieveResponse,
  ApiSessionRetrieveResponse,
  ApiSignupCreateData,
  ApiSignupCreateResponse,
  ApiSkillListData,
  ApiSkillListResponse,
  ApiSkillCreateData,
  ApiSkillCreateResponse,
  ApiSkillCategoriesListData,
  ApiSkillCategoriesListResponse,
  ApiSkillCategoriesRetrieveData,
  ApiSkillCategoriesRetrieveResponse,
  ApiSkillRetrieveData,
  ApiSkillRetrieveResponse,
  ApiSkillUpdateData,
  ApiSkillUpdateResponse,
  ApiSkillPartialUpdateData,
  ApiSkillPartialUpdateResponse,
  ApiSkillDestroyData,
  ApiSkillDestroyResponse,
  ApiSmallbizProfileListData,
  ApiSmallbizProfileListResponse,
  ApiSmallbizProfileCreateData,
  ApiSmallbizProfileCreateResponse,
  ApiSmallbizProfileRetrieveData,
  ApiSmallbizProfileRetrieveResponse,
  ApiSmallbizProfileUpdateData,
  ApiSmallbizProfileUpdateResponse,
  ApiSmallbizProfilePartialUpdateData,
  ApiSmallbizProfilePartialUpdateResponse,
  ApiSmallbizProfileDestroyData,
  ApiSmallbizProfileDestroyResponse,
  ApiTagsListData,
  ApiTagsListResponse,
  ApiTagsRetrieveData,
  ApiTagsRetrieveResponse,
  ApiTagsPopularRetrieveResponse,
  ApiUserSkillMatricesListData,
  ApiUserSkillMatricesListResponse,
  ApiUserSkillMatricesCreateData,
  ApiUserSkillMatricesCreateResponse,
  ApiUserSkillMatricesRetrieveData,
  ApiUserSkillMatricesRetrieveResponse,
  ApiUserSkillMatricesUpdateData,
  ApiUserSkillMatricesUpdateResponse,
  ApiUserSkillMatricesPartialUpdateData,
  ApiUserSkillMatricesPartialUpdateResponse,
  ApiUserSkillMatricesDestroyData,
  ApiUserSkillMatricesDestroyResponse,
  ApiUserSkillMatricesUpdateSkillCreateData,
  ApiUserSkillMatricesUpdateSkillCreateResponse,
  ApiUsersListData,
  ApiUsersListResponse,
  ApiUsersCreateData,
  ApiUsersCreateResponse,
  ApiUsersRetrieveData,
  ApiUsersRetrieveResponse,
  ApiUsersUpdateData,
  ApiUsersUpdateResponse,
  ApiUsersPartialUpdateData,
  ApiUsersPartialUpdateResponse,
  ApiUsersDestroyData,
  ApiUsersDestroyResponse,
  ApiUsersDashboardJobSearchStatsRetrieveData,
  ApiUsersDashboardJobSearchStatsRetrieveResponse,
  ApiUsersDashboardProfileCompletionRetrieveResponse,
  ApiUsersDashboardRecentActivityRetrieveResponse,
  ApiVolunteerOpportunitiesListData,
  ApiVolunteerOpportunitiesListResponse,
  ApiVolunteerOpportunitiesCreateData,
  ApiVolunteerOpportunitiesCreateResponse,
  ApiVolunteerOpportunitiesRetrieveData,
  ApiVolunteerOpportunitiesRetrieveResponse,
  ApiVolunteerOpportunitiesUpdateData,
  ApiVolunteerOpportunitiesUpdateResponse,
  ApiVolunteerOpportunitiesPartialUpdateData,
  ApiVolunteerOpportunitiesPartialUpdateResponse,
  ApiVolunteerOpportunitiesDestroyData,
  ApiVolunteerOpportunitiesDestroyResponse,
  ApiVolunteerOpportunitiesMyOpportunitiesRetrieveResponse,
  ApiWhoamiRetrieveResponse,
  ApiCandidateProfileRetrieveData,
  ApiCandidateProfileRetrieveResponse,
  ApiSearchCandidatesRetrieveData,
  ApiSearchCandidatesRetrieveResponse,
  ApiSearchCandidatesCreateData,
  ApiSearchCandidatesCreateResponse,
  ApiSearchSuggestionsRetrieveData,
  ApiSearchSuggestionsRetrieveResponse,
  ApiSendEmailCreateData,
  ApiSendEmailCreateResponse,
  CommonRestCheckRetrieveResponse,
  CommonResumeAutoPrefillRetrieveData,
  CommonResumeAutoPrefillRetrieveResponse,
  CommonResumeEnhancedCreateData,
  CommonResumeEnhancedCreateResponse,
  CommonResumeResultRetrieveData,
  CommonResumeResultRetrieveResponse,
  CommonResumeUploadRetrieveResponse,
  CommonResumeUploadCreateData,
  CommonResumeUploadCreateResponse,
  CommonResumeUploadUpdateData,
  CommonResumeUploadUpdateResponse,
  CommonResumeUploadDestroyResponse,
} from "./types.gen";

export class ApiService {
  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedApplicationList
   * @throws ApiError
   */
  public static apiApplicationList(
    data: ApiApplicationListData = {},
  ): CancelablePromise<ApiApplicationListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/application/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Application
   * @throws ApiError
   */
  public static apiApplicationCreate(
    data: ApiApplicationCreateData,
  ): CancelablePromise<ApiApplicationCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/application/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this application.
   * @returns Application
   * @throws ApiError
   */
  public static apiApplicationRetrieve(
    data: ApiApplicationRetrieveData,
  ): CancelablePromise<ApiApplicationRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/application/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this application.
   * @param data.requestBody
   * @returns Application
   * @throws ApiError
   */
  public static apiApplicationUpdate(
    data: ApiApplicationUpdateData,
  ): CancelablePromise<ApiApplicationUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/application/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this application.
   * @param data.requestBody
   * @returns Application
   * @throws ApiError
   */
  public static apiApplicationPartialUpdate(
    data: ApiApplicationPartialUpdateData,
  ): CancelablePromise<ApiApplicationPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/application/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this application.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiApplicationDestroy(
    data: ApiApplicationDestroyData,
  ): CancelablePromise<ApiApplicationDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/application/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedAwardList
   * @throws ApiError
   */
  public static apiAwardList(
    data: ApiAwardListData = {},
  ): CancelablePromise<ApiAwardListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/award/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Award
   * @throws ApiError
   */
  public static apiAwardCreate(
    data: ApiAwardCreateData,
  ): CancelablePromise<ApiAwardCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/award/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this award.
   * @returns Award
   * @throws ApiError
   */
  public static apiAwardRetrieve(
    data: ApiAwardRetrieveData,
  ): CancelablePromise<ApiAwardRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/award/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this award.
   * @param data.requestBody
   * @returns Award
   * @throws ApiError
   */
  public static apiAwardUpdate(
    data: ApiAwardUpdateData,
  ): CancelablePromise<ApiAwardUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/award/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this award.
   * @param data.requestBody
   * @returns Award
   * @throws ApiError
   */
  public static apiAwardPartialUpdate(
    data: ApiAwardPartialUpdateData,
  ): CancelablePromise<ApiAwardPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/award/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this award.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiAwardDestroy(
    data: ApiAwardDestroyData,
  ): CancelablePromise<ApiAwardDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/award/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get candidate preferences
   * Returns current preferences with available choices
   * @returns CandidatePreferences
   * @throws ApiError
   */
  public static apiCandidatePreferencesRetrieve(): CancelablePromise<ApiCandidatePreferencesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/candidate-preferences/",
    });
  }

  /**
   * Update candidate preferences
   * Update candidate preferences
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CandidatePreferences
   * @throws ApiError
   */
  public static apiCandidatePreferencesUpdate(
    data: ApiCandidatePreferencesUpdateData = {},
  ): CancelablePromise<ApiCandidatePreferencesUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/candidate-preferences/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedCertificationList
   * @throws ApiError
   */
  public static apiCertificationList(
    data: ApiCertificationListData = {},
  ): CancelablePromise<ApiCertificationListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/certification/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Certification
   * @throws ApiError
   */
  public static apiCertificationCreate(
    data: ApiCertificationCreateData,
  ): CancelablePromise<ApiCertificationCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/certification/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this certification.
   * @returns Certification
   * @throws ApiError
   */
  public static apiCertificationRetrieve(
    data: ApiCertificationRetrieveData,
  ): CancelablePromise<ApiCertificationRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/certification/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this certification.
   * @param data.requestBody
   * @returns Certification
   * @throws ApiError
   */
  public static apiCertificationUpdate(
    data: ApiCertificationUpdateData,
  ): CancelablePromise<ApiCertificationUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/certification/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this certification.
   * @param data.requestBody
   * @returns Certification
   * @throws ApiError
   */
  public static apiCertificationPartialUpdate(
    data: ApiCertificationPartialUpdateData,
  ): CancelablePromise<ApiCertificationPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/certification/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this certification.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiCertificationDestroy(
    data: ApiCertificationDestroyData,
  ): CancelablePromise<ApiCertificationDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/certification/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Read-only feed of shipped changes: one entry per merged PR.
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedChangeLogEntryList
   * @throws ApiError
   */
  public static apiChangelogList(
    data: ApiChangelogListData = {},
  ): CancelablePromise<ApiChangelogListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/changelog/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * Read-only feed of shipped changes: one entry per merged PR.
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this change log entry.
   * @returns ChangeLogEntry
   * @throws ApiError
   */
  public static apiChangelogRetrieve(
    data: ApiChangelogRetrieveData,
  ): CancelablePromise<ApiChangelogRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/changelog/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedCompanyList
   * @throws ApiError
   */
  public static apiCompanyList(
    data: ApiCompanyListData = {},
  ): CancelablePromise<ApiCompanyListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/company/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Company
   * @throws ApiError
   */
  public static apiCompanyCreate(
    data: ApiCompanyCreateData,
  ): CancelablePromise<ApiCompanyCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/company/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this company.
   * @returns Company
   * @throws ApiError
   */
  public static apiCompanyRetrieve(
    data: ApiCompanyRetrieveData,
  ): CancelablePromise<ApiCompanyRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/company/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this company.
   * @param data.requestBody
   * @returns Company
   * @throws ApiError
   */
  public static apiCompanyUpdate(
    data: ApiCompanyUpdateData,
  ): CancelablePromise<ApiCompanyUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/company/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this company.
   * @param data.requestBody
   * @returns Company
   * @throws ApiError
   */
  public static apiCompanyPartialUpdate(
    data: ApiCompanyPartialUpdateData,
  ): CancelablePromise<ApiCompanyPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/company/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this company.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiCompanyDestroy(
    data: ApiCompanyDestroyData,
  ): CancelablePromise<ApiCompanyDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/company/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedEducationList
   * @throws ApiError
   */
  public static apiEducationList(
    data: ApiEducationListData = {},
  ): CancelablePromise<ApiEducationListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/education/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Education
   * @throws ApiError
   */
  public static apiEducationCreate(
    data: ApiEducationCreateData,
  ): CancelablePromise<ApiEducationCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/education/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this education.
   * @returns Education
   * @throws ApiError
   */
  public static apiEducationRetrieve(
    data: ApiEducationRetrieveData,
  ): CancelablePromise<ApiEducationRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/education/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this education.
   * @param data.requestBody
   * @returns Education
   * @throws ApiError
   */
  public static apiEducationUpdate(
    data: ApiEducationUpdateData,
  ): CancelablePromise<ApiEducationUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/education/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this education.
   * @param data.requestBody
   * @returns Education
   * @throws ApiError
   */
  public static apiEducationPartialUpdate(
    data: ApiEducationPartialUpdateData,
  ): CancelablePromise<ApiEducationPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/education/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this education.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiEducationDestroy(
    data: ApiEducationDestroyData,
  ): CancelablePromise<ApiEducationDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/education/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.city
   * @param data.cost
   * @param data.costGte
   * @param data.costLte
   * @param data.country
   * @param data.description
   * @param data.endDateFrom
   * @param data.endDateTo
   * @param data.eventType * `workshop` - Workshop
   * * `seminar` - Seminar
   * * `conference` - Conference
   * * `networking` - Networking
   * * `training` - Training
   * * `webinar` - Webinar
   * * `other` - Other
   * @param data.eventTypeIn Multiple values may be separated by commas.
   * @param data.isActive
   * @param data.isFree
   * @param data.isOnline
   * @param data.limit Number of results to return per page.
   * @param data.location
   * @param data.offset The initial index from which to return the results.
   * @param data.organizerName
   * @param data.registrationOpen
   * @param data.registrationRequired
   * @param data.startDateFrom
   * @param data.startDateTo
   * @param data.tags
   * @param data.title
   * @param data.upcoming
   * @returns PaginatedEventListList
   * @throws ApiError
   */
  public static apiEventsList(
    data: ApiEventsListData = {},
  ): CancelablePromise<ApiEventsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/events/",
      query: {
        city: data.city,
        cost: data.cost,
        cost__gte: data.costGte,
        cost__lte: data.costLte,
        country: data.country,
        description: data.description,
        end_date_from: data.endDateFrom,
        end_date_to: data.endDateTo,
        event_type: data.eventType,
        event_type__in: data.eventTypeIn,
        is_active: data.isActive,
        is_free: data.isFree,
        is_online: data.isOnline,
        limit: data.limit,
        location: data.location,
        offset: data.offset,
        organizer_name: data.organizerName,
        registration_open: data.registrationOpen,
        registration_required: data.registrationRequired,
        start_date_from: data.startDateFrom,
        start_date_to: data.startDateTo,
        tags: data.tags,
        title: data.title,
        upcoming: data.upcoming,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Event
   * @throws ApiError
   */
  public static apiEventsCreate(
    data: ApiEventsCreateData,
  ): CancelablePromise<ApiEventsCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/events/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this event.
   * @returns Event
   * @throws ApiError
   */
  public static apiEventsRetrieve(
    data: ApiEventsRetrieveData,
  ): CancelablePromise<ApiEventsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/events/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this event.
   * @param data.requestBody
   * @returns Event
   * @throws ApiError
   */
  public static apiEventsUpdate(
    data: ApiEventsUpdateData,
  ): CancelablePromise<ApiEventsUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/events/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this event.
   * @param data.requestBody
   * @returns Event
   * @throws ApiError
   */
  public static apiEventsPartialUpdate(
    data: ApiEventsPartialUpdateData,
  ): CancelablePromise<ApiEventsPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/events/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this event.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiEventsDestroy(
    data: ApiEventsDestroyData,
  ): CancelablePromise<ApiEventsDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/events/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this event.
   * @param data.requestBody
   * @returns Event
   * @throws ApiError
   */
  public static apiEventsIncrementParticipantsCreate(
    data: ApiEventsIncrementParticipantsCreateData,
  ): CancelablePromise<ApiEventsIncrementParticipantsCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/events/{id}/increment_participants/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get events happening today
   * @returns Event
   * @throws ApiError
   */
  public static apiEventsTodayRetrieve(): CancelablePromise<ApiEventsTodayRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/events/today/",
    });
  }

  /**
   * Get upcoming events (next 30 days)
   * @returns Event
   * @throws ApiError
   */
  public static apiEventsUpcomingRetrieve(): CancelablePromise<ApiEventsUpcomingRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/events/upcoming/",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedExperienceList
   * @throws ApiError
   */
  public static apiExperienceList(
    data: ApiExperienceListData = {},
  ): CancelablePromise<ApiExperienceListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/experience/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Experience
   * @throws ApiError
   */
  public static apiExperienceCreate(
    data: ApiExperienceCreateData,
  ): CancelablePromise<ApiExperienceCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/experience/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this experience.
   * @returns Experience
   * @throws ApiError
   */
  public static apiExperienceRetrieve(
    data: ApiExperienceRetrieveData,
  ): CancelablePromise<ApiExperienceRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/experience/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this experience.
   * @param data.requestBody
   * @returns Experience
   * @throws ApiError
   */
  public static apiExperienceUpdate(
    data: ApiExperienceUpdateData,
  ): CancelablePromise<ApiExperienceUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/experience/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this experience.
   * @param data.requestBody
   * @returns Experience
   * @throws ApiError
   */
  public static apiExperiencePartialUpdate(
    data: ApiExperiencePartialUpdateData,
  ): CancelablePromise<ApiExperiencePartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/experience/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this experience.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiExperienceDestroy(
    data: ApiExperienceDestroyData,
  ): CancelablePromise<ApiExperienceDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/experience/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns GoogleAuth
   * @throws ApiError
   */
  public static apiGoogleloginCreate(
    data: ApiGoogleloginCreateData,
  ): CancelablePromise<ApiGoogleloginCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/googlelogin/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for job skill matrices
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedJobSkillMatrixList
   * @throws ApiError
   */
  public static apiJobSkillMatricesList(
    data: ApiJobSkillMatricesListData = {},
  ): CancelablePromise<ApiJobSkillMatricesListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/job-skill-matrices/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * API endpoint for job skill matrices
   * @param data The data for the request.
   * @param data.requestBody
   * @returns JobSkillMatrix
   * @throws ApiError
   */
  public static apiJobSkillMatricesCreate(
    data: ApiJobSkillMatricesCreateData,
  ): CancelablePromise<ApiJobSkillMatricesCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/job-skill-matrices/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for job skill matrices
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this job skill matrix.
   * @returns JobSkillMatrix
   * @throws ApiError
   */
  public static apiJobSkillMatricesRetrieve(
    data: ApiJobSkillMatricesRetrieveData,
  ): CancelablePromise<ApiJobSkillMatricesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/job-skill-matrices/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * API endpoint for job skill matrices
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this job skill matrix.
   * @param data.requestBody
   * @returns JobSkillMatrix
   * @throws ApiError
   */
  public static apiJobSkillMatricesUpdate(
    data: ApiJobSkillMatricesUpdateData,
  ): CancelablePromise<ApiJobSkillMatricesUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/job-skill-matrices/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for job skill matrices
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this job skill matrix.
   * @param data.requestBody
   * @returns JobSkillMatrix
   * @throws ApiError
   */
  public static apiJobSkillMatricesPartialUpdate(
    data: ApiJobSkillMatricesPartialUpdateData,
  ): CancelablePromise<ApiJobSkillMatricesPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/job-skill-matrices/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for job skill matrices
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this job skill matrix.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiJobSkillMatricesDestroy(
    data: ApiJobSkillMatricesDestroyData,
  ): CancelablePromise<ApiJobSkillMatricesDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/job-skill-matrices/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update a specific skill in the job's matrix
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this job skill matrix.
   * @param data.requestBody
   * @returns JobSkillMatrix
   * @throws ApiError
   */
  public static apiJobSkillMatricesUpdateSkillCreate(
    data: ApiJobSkillMatricesUpdateSkillCreateData,
  ): CancelablePromise<ApiJobSkillMatricesUpdateSkillCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/job-skill-matrices/{id}/update_skill/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Job postings. ``list``/``retrieve`` are scoped to active postings only,
   * so this also serves as the general (unmatched) browse feed for Explore.
   * @param data The data for the request.
   * @param data.city
   * @param data.country
   * @param data.description
   * @param data.isRemote
   * @param data.jobType * `full-time` - Full Time
   * * `intern` - Intern
   * * `volunteering` - Volunteering
   * @param data.jobTypeIn Multiple values may be separated by commas.
   * @param data.keywords
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @param data.salaryMax
   * @param data.salaryMin
   * @param data.state
   * @param data.title
   * @param data.visaSponsor
   * @returns PaginatedJobProfileList
   * @throws ApiError
   */
  public static apiJobprofileList(
    data: ApiJobprofileListData = {},
  ): CancelablePromise<ApiJobprofileListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/jobprofile/",
      query: {
        city: data.city,
        country: data.country,
        description: data.description,
        is_remote: data.isRemote,
        job_type: data.jobType,
        job_type__in: data.jobTypeIn,
        keywords: data.keywords,
        limit: data.limit,
        offset: data.offset,
        salary_max: data.salaryMax,
        salary_min: data.salaryMin,
        state: data.state,
        title: data.title,
        visa_sponsor: data.visaSponsor,
      },
    });
  }

  /**
   * Job postings. ``list``/``retrieve`` are scoped to active postings only,
   * so this also serves as the general (unmatched) browse feed for Explore.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns JobProfile
   * @throws ApiError
   */
  public static apiJobprofileCreate(
    data: ApiJobprofileCreateData,
  ): CancelablePromise<ApiJobprofileCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/jobprofile/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Job postings. ``list``/``retrieve`` are scoped to active postings only,
   * so this also serves as the general (unmatched) browse feed for Explore.
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this job profile.
   * @returns JobProfile
   * @throws ApiError
   */
  public static apiJobprofileRetrieve(
    data: ApiJobprofileRetrieveData,
  ): CancelablePromise<ApiJobprofileRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/jobprofile/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Job postings. ``list``/``retrieve`` are scoped to active postings only,
   * so this also serves as the general (unmatched) browse feed for Explore.
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this job profile.
   * @param data.requestBody
   * @returns JobProfile
   * @throws ApiError
   */
  public static apiJobprofileUpdate(
    data: ApiJobprofileUpdateData,
  ): CancelablePromise<ApiJobprofileUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/jobprofile/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Job postings. ``list``/``retrieve`` are scoped to active postings only,
   * so this also serves as the general (unmatched) browse feed for Explore.
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this job profile.
   * @param data.requestBody
   * @returns JobProfile
   * @throws ApiError
   */
  public static apiJobprofilePartialUpdate(
    data: ApiJobprofilePartialUpdateData,
  ): CancelablePromise<ApiJobprofilePartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/jobprofile/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Job postings. ``list``/``retrieve`` are scoped to active postings only,
   * so this also serves as the general (unmatched) browse feed for Explore.
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this job profile.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiJobprofileDestroy(
    data: ApiJobprofileDestroyData,
  ): CancelablePromise<ApiJobprofileDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/jobprofile/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Commissioner overrides + the immutable audit log (staff/superuser only).
   *
   * These act across chapters and teams, so they require more than ordinary
   * chapter-organizer standing -- see ``IsCommissioner``.
   *
   * Every override requires a ``reason_code`` and ``narrative``; the audit entry
   * is written first, so a missing justification aborts the whole action.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueCommissionerRetrieve(): CancelablePromise<ApiLeagueCommissionerRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/commissioner/",
    });
  }

  /**
   * Commissioner overrides + the immutable audit log (staff/superuser only).
   *
   * These act across chapters and teams, so they require more than ordinary
   * chapter-organizer standing -- see ``IsCommissioner``.
   *
   * Every override requires a ``reason_code`` and ``narrative``; the audit entry
   * is written first, so a missing justification aborts the whole action.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueCommissionerLedgerCreate(): CancelablePromise<ApiLeagueCommissionerLedgerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/commissioner/ledger/",
    });
  }

  /**
   * Commissioner overrides + the immutable audit log (staff/superuser only).
   *
   * These act across chapters and teams, so they require more than ordinary
   * chapter-organizer standing -- see ``IsCommissioner``.
   *
   * Every override requires a ``reason_code`` and ``narrative``; the audit entry
   * is written first, so a missing justification aborts the whole action.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueCommissionerRosterCreate(): CancelablePromise<ApiLeagueCommissionerRosterCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/commissioner/roster/",
    });
  }

  /**
   * Commissioner overrides + the immutable audit log (staff/superuser only).
   *
   * These act across chapters and teams, so they require more than ordinary
   * chapter-organizer standing -- see ``IsCommissioner``.
   *
   * Every override requires a ``reason_code`` and ``narrative``; the audit entry
   * is written first, so a missing justification aborts the whole action.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueCommissionerTimelineCreate(): CancelablePromise<ApiLeagueCommissionerTimelineCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/commissioner/timeline/",
    });
  }

  /**
   * The Free Agent Hub: list available developers and manage your status.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueFreeAgentsRetrieve(): CancelablePromise<ApiLeagueFreeAgentsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/free-agents/",
    });
  }

  /**
   * The Free Agent Hub: list available developers and manage your status.
   * @returns FreeAgent
   * @throws ApiError
   */
  public static apiLeagueFreeAgentsMeRetrieve(): CancelablePromise<ApiLeagueFreeAgentsMeRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/free-agents/me/",
    });
  }

  /**
   * The Free Agent Hub: list available developers and manage your status.
   * @returns FreeAgent
   * @throws ApiError
   */
  public static apiLeagueFreeAgentsMeUpdate(): CancelablePromise<ApiLeagueFreeAgentsMeUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/league/free-agents/me/",
    });
  }

  /**
   * Organizer-mode judging: score submissions against a rubric, then finalize.
   *
   * ``GET ?hackathon=<id>`` returns the rubric and the judgeable submissions
   * (with the current averaged score and this judge's own scores). ``POST``
   * upserts this judge's evaluation. ``POST finalize/`` ranks the judged
   * submissions and awards podium points via the ledger.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueJudgingRetrieve(): CancelablePromise<ApiLeagueJudgingRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/judging/",
    });
  }

  /**
   * Organizer-mode judging: score submissions against a rubric, then finalize.
   *
   * ``GET ?hackathon=<id>`` returns the rubric and the judgeable submissions
   * (with the current averaged score and this judge's own scores). ``POST``
   * upserts this judge's evaluation. ``POST finalize/`` ranks the judged
   * submissions and awards podium points via the ledger.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueJudgingCreate(): CancelablePromise<ApiLeagueJudgingCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/judging/",
    });
  }

  /**
   * Organizer-mode judging: score submissions against a rubric, then finalize.
   *
   * ``GET ?hackathon=<id>`` returns the rubric and the judgeable submissions
   * (with the current averaged score and this judge's own scores). ``POST``
   * upserts this judge's evaluation. ``POST finalize/`` ranks the judged
   * submissions and awards podium points via the ledger.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueJudgingFinalizeCreate(): CancelablePromise<ApiLeagueJudgingFinalizeCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/judging/finalize/",
    });
  }

  /**
   * Read-only League leaderboards for developers, teams, and chapters.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueLeaderboardRetrieve(): CancelablePromise<ApiLeagueLeaderboardRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/leaderboard/",
    });
  }

  /**
   * Read-only League leaderboards for developers, teams, and chapters.
   * @param data The data for the request.
   * @param data.tier Filter to a single chapter tier.
   * @returns ChapterLeaderboard
   * @throws ApiError
   */
  public static apiLeagueLeaderboardChaptersList(
    data: ApiLeagueLeaderboardChaptersListData = {},
  ): CancelablePromise<ApiLeagueLeaderboardChaptersListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/leaderboard/chapters/",
      query: {
        tier: data.tier,
      },
    });
  }

  /**
   * Read-only League leaderboards for developers, teams, and chapters.
   * @param data The data for the request.
   * @param data.tier Filter to a single chapter tier.
   * @returns DeveloperLeaderboard
   * @throws ApiError
   */
  public static apiLeagueLeaderboardDevelopersList(
    data: ApiLeagueLeaderboardDevelopersListData = {},
  ): CancelablePromise<ApiLeagueLeaderboardDevelopersListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/leaderboard/developers/",
      query: {
        tier: data.tier,
      },
    });
  }

  /**
   * Read-only League leaderboards for developers, teams, and chapters.
   * @param data The data for the request.
   * @param data.status Filter to a single team status.
   * @returns TeamLeaderboard
   * @throws ApiError
   */
  public static apiLeagueLeaderboardTeamsList(
    data: ApiLeagueLeaderboardTeamsListData = {},
  ): CancelablePromise<ApiLeagueLeaderboardTeamsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/leaderboard/teams/",
      query: {
        status: data.status,
      },
    });
  }

  /**
   * Read and switch the League dual-role mode (developer/organizer).
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueModeRetrieve(): CancelablePromise<ApiLeagueModeRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/mode/",
    });
  }

  /**
   * Read and switch the League dual-role mode (developer/organizer).
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueModeSwitchCreate(): CancelablePromise<ApiLeagueModeSwitchCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/mode/switch/",
    });
  }

  /**
   * Hackathons (challenges) matched to the current developer by skill fit.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueMyChallengesRetrieve(): CancelablePromise<ApiLeagueMyChallengesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/my-challenges/",
    });
  }

  /**
   * The current developer's points total and recent ledger entries.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueMyScoreRetrieve(): CancelablePromise<ApiLeagueMyScoreRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/my-score/",
    });
  }

  /**
   * The current user's League notifications (e.g. promotion alerts).
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueNotificationsRetrieve(): CancelablePromise<ApiLeagueNotificationsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/notifications/",
    });
  }

  /**
   * The current user's League notifications (e.g. promotion alerts).
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueNotificationsReadAllCreate(): CancelablePromise<ApiLeagueNotificationsReadAllCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/notifications/read_all/",
    });
  }

  /**
   * Organizer-only tools, blocked unless the session is in organizer mode.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueOrganizerRetrieve(): CancelablePromise<ApiLeagueOrganizerRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/organizer/",
    });
  }

  /**
   * Phase detail plus organizer freeze / bracket-generation actions.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeaguePhasesRetrieve(
    data: ApiLeaguePhasesRetrieveData,
  ): CancelablePromise<ApiLeaguePhasesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/phases/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Phase detail plus organizer freeze / bracket-generation actions.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeaguePhasesBracketCreate(
    data: ApiLeaguePhasesBracketCreateData,
  ): CancelablePromise<ApiLeaguePhasesBracketCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/phases/{id}/bracket/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Phase detail plus organizer freeze / bracket-generation actions.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeaguePhasesFreezeCreate(
    data: ApiLeaguePhasesFreezeCreateData,
  ): CancelablePromise<ApiLeaguePhasesFreezeCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/phases/{id}/freeze/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Draft-boundary-aware recruiting and the co-membership bypass.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueRecruitRetrieve(): CancelablePromise<ApiLeagueRecruitRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/recruit/",
    });
  }

  /**
   * Draft-boundary-aware recruiting and the co-membership bypass.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueRecruitCoMembershipCreate(): CancelablePromise<ApiLeagueRecruitCoMembershipCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/recruit/co_membership/",
    });
  }

  /**
   * Drive the roster handshake: apply, then advance the state machine.
   *
   * A transition can be performed by the developer or by a captain of the team.
   * ``lock`` enforces the roster cap (max 5), returning 400 if the team is full.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueRosterInvitesRetrieve(): CancelablePromise<ApiLeagueRosterInvitesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/roster-invites/",
    });
  }

  /**
   * Drive the roster handshake: apply, then advance the state machine.
   *
   * A transition can be performed by the developer or by a captain of the team.
   * ``lock`` enforces the roster cap (max 5), returning 400 if the team is full.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueRosterInvitesCreate(): CancelablePromise<ApiLeagueRosterInvitesCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/roster-invites/",
    });
  }

  /**
   * Drive the roster handshake: apply, then advance the state machine.
   *
   * A transition can be performed by the developer or by a captain of the team.
   * ``lock`` enforces the roster cap (max 5), returning 400 if the team is full.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueRosterInvitesApproveCreate(
    data: ApiLeagueRosterInvitesApproveCreateData,
  ): CancelablePromise<ApiLeagueRosterInvitesApproveCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/roster-invites/{id}/approve/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Drive the roster handshake: apply, then advance the state machine.
   *
   * A transition can be performed by the developer or by a captain of the team.
   * ``lock`` enforces the roster cap (max 5), returning 400 if the team is full.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueRosterInvitesConfirmCreate(
    data: ApiLeagueRosterInvitesConfirmCreateData,
  ): CancelablePromise<ApiLeagueRosterInvitesConfirmCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/roster-invites/{id}/confirm/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Drive the roster handshake: apply, then advance the state machine.
   *
   * A transition can be performed by the developer or by a captain of the team.
   * ``lock`` enforces the roster cap (max 5), returning 400 if the team is full.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueRosterInvitesDeclineCreate(
    data: ApiLeagueRosterInvitesDeclineCreateData,
  ): CancelablePromise<ApiLeagueRosterInvitesDeclineCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/roster-invites/{id}/decline/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Drive the roster handshake: apply, then advance the state machine.
   *
   * A transition can be performed by the developer or by a captain of the team.
   * ``lock`` enforces the roster cap (max 5), returning 400 if the team is full.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueRosterInvitesLockCreate(
    data: ApiLeagueRosterInvitesLockCreateData,
  ): CancelablePromise<ApiLeagueRosterInvitesLockCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/roster-invites/{id}/lock/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Read-only view of seasons and their four phase windows.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueSeasonsRetrieve(): CancelablePromise<ApiLeagueSeasonsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/seasons/",
    });
  }

  /**
   * Read-only view of seasons and their four phase windows.
   * @param data The data for the request.
   * @param data.id
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueSeasonsRetrieve2(
    data: ApiLeagueSeasonsRetrieve2Data,
  ): CancelablePromise<ApiLeagueSeasonsRetrieve2Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/seasons/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Solo-shell safety valve: a developer with no team can spin up a solo one.
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueSoloTeamCreate(): CancelablePromise<ApiLeagueSoloTeamCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/solo-team/",
    });
  }

  /**
   * A team's hackathon submission: draft, validate, then one-click lock.
   *
   * Editing is scoped to the submitting team's members. Locking ("Submit Final
   * Work") requires a captain. Once ``locked`` the entry is read-only and every
   * write is blocked at the API layer.
   * @returns Submission
   * @throws ApiError
   */
  public static apiLeagueSubmissionsList(): CancelablePromise<ApiLeagueSubmissionsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/submissions/",
    });
  }

  /**
   * A team's hackathon submission: draft, validate, then one-click lock.
   *
   * Editing is scoped to the submitting team's members. Locking ("Submit Final
   * Work") requires a captain. Once ``locked`` the entry is read-only and every
   * write is blocked at the API layer.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Submission
   * @throws ApiError
   */
  public static apiLeagueSubmissionsCreate(
    data: ApiLeagueSubmissionsCreateData,
  ): CancelablePromise<ApiLeagueSubmissionsCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/submissions/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * A team's hackathon submission: draft, validate, then one-click lock.
   *
   * Editing is scoped to the submitting team's members. Locking ("Submit Final
   * Work") requires a captain. Once ``locked`` the entry is read-only and every
   * write is blocked at the API layer.
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this submission.
   * @returns Submission
   * @throws ApiError
   */
  public static apiLeagueSubmissionsRetrieve(
    data: ApiLeagueSubmissionsRetrieveData,
  ): CancelablePromise<ApiLeagueSubmissionsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/submissions/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * A team's hackathon submission: draft, validate, then one-click lock.
   *
   * Editing is scoped to the submitting team's members. Locking ("Submit Final
   * Work") requires a captain. Once ``locked`` the entry is read-only and every
   * write is blocked at the API layer.
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this submission.
   * @param data.requestBody
   * @returns Submission
   * @throws ApiError
   */
  public static apiLeagueSubmissionsUpdate(
    data: ApiLeagueSubmissionsUpdateData,
  ): CancelablePromise<ApiLeagueSubmissionsUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/league/submissions/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * A team's hackathon submission: draft, validate, then one-click lock.
   *
   * Editing is scoped to the submitting team's members. Locking ("Submit Final
   * Work") requires a captain. Once ``locked`` the entry is read-only and every
   * write is blocked at the API layer.
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this submission.
   * @param data.requestBody
   * @returns Submission
   * @throws ApiError
   */
  public static apiLeagueSubmissionsPartialUpdate(
    data: ApiLeagueSubmissionsPartialUpdateData,
  ): CancelablePromise<ApiLeagueSubmissionsPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/league/submissions/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * A team's hackathon submission: draft, validate, then one-click lock.
   *
   * Editing is scoped to the submitting team's members. Locking ("Submit Final
   * Work") requires a captain. Once ``locked`` the entry is read-only and every
   * write is blocked at the API layer.
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this submission.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiLeagueSubmissionsDestroy(
    data: ApiLeagueSubmissionsDestroyData,
  ): CancelablePromise<ApiLeagueSubmissionsDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/league/submissions/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * A team's hackathon submission: draft, validate, then one-click lock.
   *
   * Editing is scoped to the submitting team's members. Locking ("Submit Final
   * Work") requires a captain. Once ``locked`` the entry is read-only and every
   * write is blocked at the API layer.
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this submission.
   * @param data.requestBody
   * @returns Submission
   * @throws ApiError
   */
  public static apiLeagueSubmissionsLockCreate(
    data: ApiLeagueSubmissionsLockCreateData,
  ): CancelablePromise<ApiLeagueSubmissionsLockCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/submissions/{id}/lock/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * A team's hackathon submission: draft, validate, then one-click lock.
   *
   * Editing is scoped to the submitting team's members. Locking ("Submit Final
   * Work") requires a captain. Once ``locked`` the entry is read-only and every
   * write is blocked at the API layer.
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this submission.
   * @param data.requestBody
   * @returns Submission
   * @throws ApiError
   */
  public static apiLeagueSubmissionsValidateCreate(
    data: ApiLeagueSubmissionsValidateCreateData,
  ): CancelablePromise<ApiLeagueSubmissionsValidateCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/league/submissions/{id}/validate/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Teams the user can submit for and hackathons currently open.
   * @returns Submission
   * @throws ApiError
   */
  public static apiLeagueSubmissionsOptionsRetrieve(): CancelablePromise<ApiLeagueSubmissionsOptionsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/submissions/options/",
    });
  }

  /**
   * Rank free agents against a team's skill gaps (reuses the matcher).
   * @param data The data for the request.
   * @param data.id
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLeagueTeamMatchesRetrieve(
    data: ApiLeagueTeamMatchesRetrieveData,
  ): CancelablePromise<ApiLeagueTeamMatchesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/league/team-matches/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Login
   * @throws ApiError
   */
  public static apiLoginCreate(
    data: ApiLoginCreateData,
  ): CancelablePromise<ApiLoginCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/login/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiLogoutCreate(): CancelablePromise<ApiLogoutCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/logout/",
    });
  }

  /**
   * API endpoint for match results (read + partial update for user actions)
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedMatchResultList
   * @throws ApiError
   */
  public static apiMatchResultsList(
    data: ApiMatchResultsListData = {},
  ): CancelablePromise<ApiMatchResultsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/match-results/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * API endpoint for match results (read + partial update for user actions)
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this match result.
   * @returns MatchResult
   * @throws ApiError
   */
  public static apiMatchResultsRetrieve(
    data: ApiMatchResultsRetrieveData,
  ): CancelablePromise<ApiMatchResultsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/match-results/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * API endpoint for match results (read + partial update for user actions)
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this match result.
   * @param data.requestBody
   * @returns MatchResult
   * @throws ApiError
   */
  public static apiMatchResultsUpdate(
    data: ApiMatchResultsUpdateData,
  ): CancelablePromise<ApiMatchResultsUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/match-results/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for match results (read + partial update for user actions)
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this match result.
   * @param data.requestBody
   * @returns MatchResult
   * @throws ApiError
   */
  public static apiMatchResultsPartialUpdate(
    data: ApiMatchResultsPartialUpdateData,
  ): CancelablePromise<ApiMatchResultsPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/match-results/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get-or-create a MatchResult for (user, job) and set user action flags on it.
   *
   * The matching algorithm only creates MatchResult rows when explicitly run,
   * so a candidate browsing the general job list has none yet. This lets the
   * save/good-fit/not-for-me actions work against any job, creating the
   * underlying match record on first interaction.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns MatchResult
   * @throws ApiError
   */
  public static apiMatchResultsSaveJobCreate(
    data: ApiMatchResultsSaveJobCreateData = {},
  ): CancelablePromise<ApiMatchResultsSaveJobCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/match-results/save-job/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for matching sessions
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedMatchingSessionList
   * @throws ApiError
   */
  public static apiMatchingSessionsList(
    data: ApiMatchingSessionsListData = {},
  ): CancelablePromise<ApiMatchingSessionsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/matching-sessions/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * API endpoint for matching sessions
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this matching session.
   * @returns MatchingSession
   * @throws ApiError
   */
  public static apiMatchingSessionsRetrieve(
    data: ApiMatchingSessionsRetrieveData,
  ): CancelablePromise<ApiMatchingSessionsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/matching-sessions/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * API endpoint for viewing skills
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedSkillList
   * @throws ApiError
   */
  public static apiMatchingSkillsList(
    data: ApiMatchingSkillsListData = {},
  ): CancelablePromise<ApiMatchingSkillsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/matching-skills/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * API endpoint for viewing skills
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this skill.
   * @returns Skill
   * @throws ApiError
   */
  public static apiMatchingSkillsRetrieve(
    data: ApiMatchingSkillsRetrieveData,
  ): CancelablePromise<ApiMatchingSkillsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/matching-skills/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get skills for autocomplete - supports prefix search and category filtering
   * @returns Skill
   * @throws ApiError
   */
  public static apiMatchingSkillsAutocompleteRetrieve(): CancelablePromise<ApiMatchingSkillsAutocompleteRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/matching-skills/autocomplete/",
    });
  }

  /**
   * Get matching analytics for the user
   * @returns MatchingSession
   * @throws ApiError
   */
  public static apiMatchingAnalyticsRetrieve(): CancelablePromise<ApiMatchingAnalyticsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/matching/analytics/",
    });
  }

  /**
   * Extract skills from job description
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Skill
   * @throws ApiError
   */
  public static apiMatchingExtractSkillsCreate(
    data: ApiMatchingExtractSkillsCreateData,
  ): CancelablePromise<ApiMatchingExtractSkillsCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/matching/extract-skills/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get user's recent matches
   * @returns MatchResult
   * @throws ApiError
   */
  public static apiMatchingMatchRetrieve(): CancelablePromise<ApiMatchingMatchRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/matching/match/",
    });
  }

  /**
   * Run matching for the authenticated user
   * @param data The data for the request.
   * @param data.requestBody
   * @returns MatchResult
   * @throws ApiError
   */
  public static apiMatchingMatchCreate(
    data: ApiMatchingMatchCreateData = {},
  ): CancelablePromise<ApiMatchingMatchCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/matching/match/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get status of a Celery task
   * @returns unknown No response body
   * @throws ApiError
   */
  public static apiMatchingTaskStatusRetrieve(): CancelablePromise<ApiMatchingTaskStatusRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/matching/task-status/",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedNonProfitProfileList
   * @throws ApiError
   */
  public static apiNonprofitProfileList(
    data: ApiNonprofitProfileListData = {},
  ): CancelablePromise<ApiNonprofitProfileListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/nonprofit-profile/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns NonProfitProfile
   * @throws ApiError
   */
  public static apiNonprofitProfileCreate(
    data: ApiNonprofitProfileCreateData,
  ): CancelablePromise<ApiNonprofitProfileCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/nonprofit-profile/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this non profit profile.
   * @returns NonProfitProfile
   * @throws ApiError
   */
  public static apiNonprofitProfileRetrieve(
    data: ApiNonprofitProfileRetrieveData,
  ): CancelablePromise<ApiNonprofitProfileRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/nonprofit-profile/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this non profit profile.
   * @param data.requestBody
   * @returns NonProfitProfile
   * @throws ApiError
   */
  public static apiNonprofitProfileUpdate(
    data: ApiNonprofitProfileUpdateData,
  ): CancelablePromise<ApiNonprofitProfileUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/nonprofit-profile/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this non profit profile.
   * @param data.requestBody
   * @returns NonProfitProfile
   * @throws ApiError
   */
  public static apiNonprofitProfilePartialUpdate(
    data: ApiNonprofitProfilePartialUpdateData,
  ): CancelablePromise<ApiNonprofitProfilePartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/nonprofit-profile/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this non profit profile.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiNonprofitProfileDestroy(
    data: ApiNonprofitProfileDestroyData,
  ): CancelablePromise<ApiNonprofitProfileDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/nonprofit-profile/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedProfileList
   * @throws ApiError
   */
  public static apiProfileList(
    data: ApiProfileListData = {},
  ): CancelablePromise<ApiProfileListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/profile/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Profile
   * @throws ApiError
   */
  public static apiProfileCreate(
    data: ApiProfileCreateData,
  ): CancelablePromise<ApiProfileCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/profile/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this profile.
   * @returns Profile
   * @throws ApiError
   */
  public static apiProfileRetrieve(
    data: ApiProfileRetrieveData,
  ): CancelablePromise<ApiProfileRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/profile/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this profile.
   * @param data.requestBody
   * @returns Profile
   * @throws ApiError
   */
  public static apiProfileUpdate(
    data: ApiProfileUpdateData,
  ): CancelablePromise<ApiProfileUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/profile/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this profile.
   * @param data.requestBody
   * @returns Profile
   * @throws ApiError
   */
  public static apiProfilePartialUpdate(
    data: ApiProfilePartialUpdateData,
  ): CancelablePromise<ApiProfilePartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/profile/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this profile.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiProfileDestroy(
    data: ApiProfileDestroyData,
  ): CancelablePromise<ApiProfileDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/profile/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedProjectList
   * @throws ApiError
   */
  public static apiProjectList(
    data: ApiProjectListData = {},
  ): CancelablePromise<ApiProjectListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/project/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Project
   * @throws ApiError
   */
  public static apiProjectCreate(
    data: ApiProjectCreateData,
  ): CancelablePromise<ApiProjectCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/project/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this project.
   * @returns Project
   * @throws ApiError
   */
  public static apiProjectRetrieve(
    data: ApiProjectRetrieveData,
  ): CancelablePromise<ApiProjectRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/project/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this project.
   * @param data.requestBody
   * @returns Project
   * @throws ApiError
   */
  public static apiProjectUpdate(
    data: ApiProjectUpdateData,
  ): CancelablePromise<ApiProjectUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/project/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this project.
   * @param data.requestBody
   * @returns Project
   * @throws ApiError
   */
  public static apiProjectPartialUpdate(
    data: ApiProjectPartialUpdateData,
  ): CancelablePromise<ApiProjectPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/project/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this project.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiProjectDestroy(
    data: ApiProjectDestroyData,
  ): CancelablePromise<ApiProjectDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/project/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedPublicationList
   * @throws ApiError
   */
  public static apiPublicationList(
    data: ApiPublicationListData = {},
  ): CancelablePromise<ApiPublicationListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/publication/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Publication
   * @throws ApiError
   */
  public static apiPublicationCreate(
    data: ApiPublicationCreateData,
  ): CancelablePromise<ApiPublicationCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/publication/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this publication.
   * @returns Publication
   * @throws ApiError
   */
  public static apiPublicationRetrieve(
    data: ApiPublicationRetrieveData,
  ): CancelablePromise<ApiPublicationRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/publication/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this publication.
   * @param data.requestBody
   * @returns Publication
   * @throws ApiError
   */
  public static apiPublicationUpdate(
    data: ApiPublicationUpdateData,
  ): CancelablePromise<ApiPublicationUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/publication/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this publication.
   * @param data.requestBody
   * @returns Publication
   * @throws ApiError
   */
  public static apiPublicationPartialUpdate(
    data: ApiPublicationPartialUpdateData,
  ): CancelablePromise<ApiPublicationPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/publication/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this publication.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiPublicationDestroy(
    data: ApiPublicationDestroyData,
  ): CancelablePromise<ApiPublicationDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/publication/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.author
   * @param data.city
   * @param data.cost
   * @param data.costGte
   * @param data.costLte
   * @param data.country
   * @param data.description
   * @param data.isActive
   * @param data.isFree
   * @param data.language
   * @param data.languageIn Multiple values may be separated by commas.
   * @param data.limit Number of results to return per page.
   * @param data.location
   * @param data.offset The initial index from which to return the results.
   * @param data.publishedDateFrom
   * @param data.publishedDateTo
   * @param data.publisher
   * @param data.resourceType * `article` - Article
   * * `video` - Video
   * * `podcast` - Podcast
   * * `ebook` - E-Book
   * * `template` - Template
   * * `tool` - Tool
   * * `course` - Course
   * * `guide` - Guide
   * * `other` - Other
   * @param data.resourceTypeIn Multiple values may be separated by commas.
   * @param data.tags
   * @param data.title
   * @returns PaginatedResourceListList
   * @throws ApiError
   */
  public static apiResourcesList(
    data: ApiResourcesListData = {},
  ): CancelablePromise<ApiResourcesListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/resources/",
      query: {
        author: data.author,
        city: data.city,
        cost: data.cost,
        cost__gte: data.costGte,
        cost__lte: data.costLte,
        country: data.country,
        description: data.description,
        is_active: data.isActive,
        is_free: data.isFree,
        language: data.language,
        language__in: data.languageIn,
        limit: data.limit,
        location: data.location,
        offset: data.offset,
        published_date_from: data.publishedDateFrom,
        published_date_to: data.publishedDateTo,
        publisher: data.publisher,
        resource_type: data.resourceType,
        resource_type__in: data.resourceTypeIn,
        tags: data.tags,
        title: data.title,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Resource
   * @throws ApiError
   */
  public static apiResourcesCreate(
    data: ApiResourcesCreateData,
  ): CancelablePromise<ApiResourcesCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/resources/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this resource.
   * @returns Resource
   * @throws ApiError
   */
  public static apiResourcesRetrieve(
    data: ApiResourcesRetrieveData,
  ): CancelablePromise<ApiResourcesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/resources/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this resource.
   * @param data.requestBody
   * @returns Resource
   * @throws ApiError
   */
  public static apiResourcesUpdate(
    data: ApiResourcesUpdateData,
  ): CancelablePromise<ApiResourcesUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/resources/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this resource.
   * @param data.requestBody
   * @returns Resource
   * @throws ApiError
   */
  public static apiResourcesPartialUpdate(
    data: ApiResourcesPartialUpdateData,
  ): CancelablePromise<ApiResourcesPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/resources/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this resource.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiResourcesDestroy(
    data: ApiResourcesDestroyData,
  ): CancelablePromise<ApiResourcesDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/resources/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this resource.
   * @param data.requestBody
   * @returns Resource
   * @throws ApiError
   */
  public static apiResourcesIncrementDownloadsCreate(
    data: ApiResourcesIncrementDownloadsCreateData,
  ): CancelablePromise<ApiResourcesIncrementDownloadsCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/resources/{id}/increment_downloads/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this resource.
   * @param data.requestBody
   * @returns Resource
   * @throws ApiError
   */
  public static apiResourcesIncrementViewsCreate(
    data: ApiResourcesIncrementViewsCreateData,
  ): CancelablePromise<ApiResourcesIncrementViewsCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/resources/{id}/increment_views/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Get free resources only
   * @returns Resource
   * @throws ApiError
   */
  public static apiResourcesFreeRetrieve(): CancelablePromise<ApiResourcesFreeRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/resources/free/",
    });
  }

  /**
   * Get most popular resources by views
   * @returns Resource
   * @throws ApiError
   */
  public static apiResourcesPopularRetrieve(): CancelablePromise<ApiResourcesPopularRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/resources/popular/",
    });
  }

  /**
   * Check REST API
   * This endpoint checks if the REST API is working.
   * @returns Message
   * @throws ApiError
   */
  public static apiRestRestCheckRetrieve(): CancelablePromise<ApiRestRestCheckRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/rest/rest-check/",
    });
  }

  /**
   * @returns Session
   * @throws ApiError
   */
  public static apiSessionRetrieve(): CancelablePromise<ApiSessionRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/session/",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Signup
   * @throws ApiError
   */
  public static apiSignupCreate(
    data: ApiSignupCreateData,
  ): CancelablePromise<ApiSignupCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/signup/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedApplicationSkillList
   * @throws ApiError
   */
  public static apiSkillList(
    data: ApiSkillListData = {},
  ): CancelablePromise<ApiSkillListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/skill/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ApplicationSkill
   * @throws ApiError
   */
  public static apiSkillCreate(
    data: ApiSkillCreateData,
  ): CancelablePromise<ApiSkillCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/skill/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for viewing skill categories
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedSkillCategoryList
   * @throws ApiError
   */
  public static apiSkillCategoriesList(
    data: ApiSkillCategoriesListData = {},
  ): CancelablePromise<ApiSkillCategoriesListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/skill-categories/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * API endpoint for viewing skill categories
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this skill category.
   * @returns SkillCategory
   * @throws ApiError
   */
  public static apiSkillCategoriesRetrieve(
    data: ApiSkillCategoriesRetrieveData,
  ): CancelablePromise<ApiSkillCategoriesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/skill-categories/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this skill.
   * @returns ApplicationSkill
   * @throws ApiError
   */
  public static apiSkillRetrieve(
    data: ApiSkillRetrieveData,
  ): CancelablePromise<ApiSkillRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/skill/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this skill.
   * @param data.requestBody
   * @returns ApplicationSkill
   * @throws ApiError
   */
  public static apiSkillUpdate(
    data: ApiSkillUpdateData,
  ): CancelablePromise<ApiSkillUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/skill/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this skill.
   * @param data.requestBody
   * @returns ApplicationSkill
   * @throws ApiError
   */
  public static apiSkillPartialUpdate(
    data: ApiSkillPartialUpdateData,
  ): CancelablePromise<ApiSkillPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/skill/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this skill.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiSkillDestroy(
    data: ApiSkillDestroyData,
  ): CancelablePromise<ApiSkillDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/skill/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Small-business profiles, including their published problems_facing --
   * the Explore page's "businesses looking for help" feed (?has_problem=true).
   * @param data The data for the request.
   * @param data.companyName
   * @param data.hasProblem
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @param data.problemsFacing
   * @param data.seekingVolunteers
   * @param data.yearsOperating * `lt1` - Less than 1 year (Startup)
   * * `1_3` - 1-3 years
   * * `4_7` - 4-7 years
   * * `8_15` - 8-15 years
   * * `15_plus` - More than 15 years
   * @returns PaginatedSmallBusinessProfileList
   * @throws ApiError
   */
  public static apiSmallbizProfileList(
    data: ApiSmallbizProfileListData = {},
  ): CancelablePromise<ApiSmallbizProfileListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/smallbiz-profile/",
      query: {
        company_name: data.companyName,
        has_problem: data.hasProblem,
        limit: data.limit,
        offset: data.offset,
        problems_facing: data.problemsFacing,
        seeking_volunteers: data.seekingVolunteers,
        years_operating: data.yearsOperating,
      },
    });
  }

  /**
   * Small-business profiles, including their published problems_facing --
   * the Explore page's "businesses looking for help" feed (?has_problem=true).
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SmallBusinessProfile
   * @throws ApiError
   */
  public static apiSmallbizProfileCreate(
    data: ApiSmallbizProfileCreateData,
  ): CancelablePromise<ApiSmallbizProfileCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/smallbiz-profile/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Small-business profiles, including their published problems_facing --
   * the Explore page's "businesses looking for help" feed (?has_problem=true).
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this small business profile.
   * @returns SmallBusinessProfile
   * @throws ApiError
   */
  public static apiSmallbizProfileRetrieve(
    data: ApiSmallbizProfileRetrieveData,
  ): CancelablePromise<ApiSmallbizProfileRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/smallbiz-profile/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Small-business profiles, including their published problems_facing --
   * the Explore page's "businesses looking for help" feed (?has_problem=true).
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this small business profile.
   * @param data.requestBody
   * @returns SmallBusinessProfile
   * @throws ApiError
   */
  public static apiSmallbizProfileUpdate(
    data: ApiSmallbizProfileUpdateData,
  ): CancelablePromise<ApiSmallbizProfileUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/smallbiz-profile/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Small-business profiles, including their published problems_facing --
   * the Explore page's "businesses looking for help" feed (?has_problem=true).
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this small business profile.
   * @param data.requestBody
   * @returns SmallBusinessProfile
   * @throws ApiError
   */
  public static apiSmallbizProfilePartialUpdate(
    data: ApiSmallbizProfilePartialUpdateData,
  ): CancelablePromise<ApiSmallbizProfilePartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/smallbiz-profile/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Small-business profiles, including their published problems_facing --
   * the Explore page's "businesses looking for help" feed (?has_problem=true).
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this small business profile.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiSmallbizProfileDestroy(
    data: ApiSmallbizProfileDestroyData,
  ): CancelablePromise<ApiSmallbizProfileDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/smallbiz-profile/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedTagList
   * @throws ApiError
   */
  public static apiTagsList(
    data: ApiTagsListData = {},
  ): CancelablePromise<ApiTagsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tags/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this tag.
   * @returns Tag
   * @throws ApiError
   */
  public static apiTagsRetrieve(
    data: ApiTagsRetrieveData,
  ): CancelablePromise<ApiTagsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tags/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get most used tags
   * @returns Tag
   * @throws ApiError
   */
  public static apiTagsPopularRetrieve(): CancelablePromise<ApiTagsPopularRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tags/popular/",
    });
  }

  /**
   * API endpoint for user skill matrices
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedUserSkillMatrixList
   * @throws ApiError
   */
  public static apiUserSkillMatricesList(
    data: ApiUserSkillMatricesListData = {},
  ): CancelablePromise<ApiUserSkillMatricesListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user-skill-matrices/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * API endpoint for user skill matrices
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserSkillMatrix
   * @throws ApiError
   */
  public static apiUserSkillMatricesCreate(
    data: ApiUserSkillMatricesCreateData = {},
  ): CancelablePromise<ApiUserSkillMatricesCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user-skill-matrices/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for user skill matrices
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user skill matrix.
   * @returns UserSkillMatrix
   * @throws ApiError
   */
  public static apiUserSkillMatricesRetrieve(
    data: ApiUserSkillMatricesRetrieveData,
  ): CancelablePromise<ApiUserSkillMatricesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user-skill-matrices/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * API endpoint for user skill matrices
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user skill matrix.
   * @param data.requestBody
   * @returns UserSkillMatrix
   * @throws ApiError
   */
  public static apiUserSkillMatricesUpdate(
    data: ApiUserSkillMatricesUpdateData,
  ): CancelablePromise<ApiUserSkillMatricesUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/user-skill-matrices/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for user skill matrices
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user skill matrix.
   * @param data.requestBody
   * @returns UserSkillMatrix
   * @throws ApiError
   */
  public static apiUserSkillMatricesPartialUpdate(
    data: ApiUserSkillMatricesPartialUpdateData,
  ): CancelablePromise<ApiUserSkillMatricesPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/user-skill-matrices/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for user skill matrices
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user skill matrix.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiUserSkillMatricesDestroy(
    data: ApiUserSkillMatricesDestroyData,
  ): CancelablePromise<ApiUserSkillMatricesDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/user-skill-matrices/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Update a specific skill in the user's matrix
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user skill matrix.
   * @param data.requestBody
   * @returns UserSkillMatrix
   * @throws ApiError
   */
  public static apiUserSkillMatricesUpdateSkillCreate(
    data: ApiUserSkillMatricesUpdateSkillCreateData,
  ): CancelablePromise<ApiUserSkillMatricesUpdateSkillCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user-skill-matrices/{id}/update_skill/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.isActive
   * @param data.isLookingForJob
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @param data.role * `admin` - Admin
   * * `staff` - Staff
   * * `candidate` - Candidate
   * * `recruiter` - Recruiter
   * * `smallbiz_owner` - Small Business Owner
   * * `nonprofit` - Nonprofit Organization
   * @param data.search A search term.
   * @returns PaginatedUserList
   * @throws ApiError
   */
  public static apiUsersList(
    data: ApiUsersListData = {},
  ): CancelablePromise<ApiUsersListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/users/",
      query: {
        is_active: data.isActive,
        is_looking_for_job: data.isLookingForJob,
        limit: data.limit,
        offset: data.offset,
        role: data.role,
        search: data.search,
      },
    });
  }

  /**
   * Override to add permission checking for user creation
   * @param data The data for the request.
   * @param data.requestBody
   * @returns User
   * @throws ApiError
   */
  public static apiUsersCreate(
    data: ApiUsersCreateData,
  ): CancelablePromise<ApiUsersCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/users/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user.
   * @returns User
   * @throws ApiError
   */
  public static apiUsersRetrieve(
    data: ApiUsersRetrieveData,
  ): CancelablePromise<ApiUsersRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/users/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user.
   * @param data.requestBody
   * @returns User
   * @throws ApiError
   */
  public static apiUsersUpdate(
    data: ApiUsersUpdateData,
  ): CancelablePromise<ApiUsersUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/users/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user.
   * @param data.requestBody
   * @returns User
   * @throws ApiError
   */
  public static apiUsersPartialUpdate(
    data: ApiUsersPartialUpdateData,
  ): CancelablePromise<ApiUsersPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/users/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiUsersDestroy(
    data: ApiUsersDestroyData,
  ): CancelablePromise<ApiUsersDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/users/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get job search stats for the user
   * Returns job search statistics for the authenticated user over a given time period.
   * @param data The data for the request.
   * @param data.days Number of days to look back for stats (default: 30)
   * @returns unknown
   * @throws ApiError
   */
  public static apiUsersDashboardJobSearchStatsRetrieve(
    data: ApiUsersDashboardJobSearchStatsRetrieveData = {},
  ): CancelablePromise<ApiUsersDashboardJobSearchStatsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/users/dashboard/job-search-stats/",
      query: {
        days: data.days,
      },
    });
  }

  /**
   * Get profile completion percentage and checklist
   * Returns the profile completion percentage and a checklist of completed sections for the authenticated user.
   * @returns unknown
   * @throws ApiError
   */
  public static apiUsersDashboardProfileCompletionRetrieve(): CancelablePromise<ApiUsersDashboardProfileCompletionRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/users/dashboard/profile-completion/",
    });
  }

  /**
   * Get recent job application activity
   * Returns a list of recent job application activities for the authenticated user.
   * @returns unknown
   * @throws ApiError
   */
  public static apiUsersDashboardRecentActivityRetrieve(): CancelablePromise<ApiUsersDashboardRecentActivityRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/users/dashboard/recent-activity/",
    });
  }

  /**
   * API endpoint for volunteer opportunities
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @returns PaginatedVolunteerOpportunityList
   * @throws ApiError
   */
  public static apiVolunteerOpportunitiesList(
    data: ApiVolunteerOpportunitiesListData = {},
  ): CancelablePromise<ApiVolunteerOpportunitiesListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/volunteer-opportunities/",
      query: {
        limit: data.limit,
        offset: data.offset,
      },
    });
  }

  /**
   * API endpoint for volunteer opportunities
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VolunteerOpportunity
   * @throws ApiError
   */
  public static apiVolunteerOpportunitiesCreate(
    data: ApiVolunteerOpportunitiesCreateData,
  ): CancelablePromise<ApiVolunteerOpportunitiesCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/volunteer-opportunities/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for volunteer opportunities
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this volunteer opportunity.
   * @returns VolunteerOpportunity
   * @throws ApiError
   */
  public static apiVolunteerOpportunitiesRetrieve(
    data: ApiVolunteerOpportunitiesRetrieveData,
  ): CancelablePromise<ApiVolunteerOpportunitiesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/volunteer-opportunities/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * API endpoint for volunteer opportunities
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this volunteer opportunity.
   * @param data.requestBody
   * @returns VolunteerOpportunity
   * @throws ApiError
   */
  public static apiVolunteerOpportunitiesUpdate(
    data: ApiVolunteerOpportunitiesUpdateData,
  ): CancelablePromise<ApiVolunteerOpportunitiesUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/volunteer-opportunities/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for volunteer opportunities
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this volunteer opportunity.
   * @param data.requestBody
   * @returns VolunteerOpportunity
   * @throws ApiError
   */
  public static apiVolunteerOpportunitiesPartialUpdate(
    data: ApiVolunteerOpportunitiesPartialUpdateData,
  ): CancelablePromise<ApiVolunteerOpportunitiesPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/volunteer-opportunities/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint for volunteer opportunities
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this volunteer opportunity.
   * @returns void No response body
   * @throws ApiError
   */
  public static apiVolunteerOpportunitiesDestroy(
    data: ApiVolunteerOpportunitiesDestroyData,
  ): CancelablePromise<ApiVolunteerOpportunitiesDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/volunteer-opportunities/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Get volunteer opportunities created by the user's company
   * @returns VolunteerOpportunity
   * @throws ApiError
   */
  public static apiVolunteerOpportunitiesMyOpportunitiesRetrieve(): CancelablePromise<ApiVolunteerOpportunitiesMyOpportunitiesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/volunteer-opportunities/my_opportunities/",
    });
  }

  /**
   * @returns WhoAmI
   * @throws ApiError
   */
  public static apiWhoamiRetrieve(): CancelablePromise<ApiWhoamiRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/whoami/",
    });
  }
}

export class CandidatesService {
  /**
   * Get candidate profile for recruiters
   * Returns comprehensive candidate profile data including user info, application, skills, experience, and education. Only accessible by recruiters, staff, and admins.
   * @param data The data for the request.
   * @param data.candidateId ID of the candidate to view
   * @returns CandidatePublicProfile
   * @throws ApiError
   */
  public static apiCandidateProfileRetrieve(
    data: ApiCandidateProfileRetrieveData,
  ): CancelablePromise<ApiCandidateProfileRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/candidate-profile/{candidate_id}/",
      path: {
        candidate_id: data.candidateId,
      },
      errors: {
        403: "Access denied - only recruiters, staff, and admins can view candidate profiles",
        404: "Candidate not found or not looking for jobs",
      },
    });
  }

  /**
   * Search candidates using GET method
   * Alternative GET method for candidate search with query parameters
   * @param data The data for the request.
   * @param data.q Search query
   * @param data.limit Maximum number of results
   * @returns SearchResponse
   * @throws ApiError
   */
  public static apiSearchCandidatesRetrieve(
    data: ApiSearchCandidatesRetrieveData,
  ): CancelablePromise<ApiSearchCandidatesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/search/candidates/",
      query: {
        limit: data.limit,
        q: data.q,
      },
      errors: {
        400: "Invalid request parameters",
        403: "Access denied",
        500: "Internal server error",
      },
    });
  }

  /**
   * Search candidates using natural language
   *
   * Search for candidates using natural language queries. The system will:
   * - Parse job roles, locations, experience levels, and skills from your query
   * - Search across candidate profiles, experiences, education, and skills
   * - Rank results by relevance using both text search and matching algorithms
   * - Return detailed candidate information with match scores
   *
   * Example queries:
   * - "backend engineer with 5 years experience around DC"
   * - "frontend developer skilled in React and TypeScript"
   * - "data scientist with machine learning experience in San Francisco"
   * - "product manager with startup experience"
   *
   * @param data The data for the request.
   * @param data.query Natural language search query
   * @param data.requestBody
   * @param data.limit Maximum number of results (default: 20, max: 100)
   * @returns SearchResponse
   * @throws ApiError
   */
  public static apiSearchCandidatesCreate(
    data: ApiSearchCandidatesCreateData,
  ): CancelablePromise<ApiSearchCandidatesCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/search/candidates/",
      query: {
        limit: data.limit,
        query: data.query,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Invalid request data",
        403: "Access denied - only recruiters can search candidates",
        500: "Internal server error",
      },
    });
  }
}

export class RecruitersService {
  /**
   * Get candidate profile for recruiters
   * Returns comprehensive candidate profile data including user info, application, skills, experience, and education. Only accessible by recruiters, staff, and admins.
   * @param data The data for the request.
   * @param data.candidateId ID of the candidate to view
   * @returns CandidatePublicProfile
   * @throws ApiError
   */
  public static apiCandidateProfileRetrieve(
    data: ApiCandidateProfileRetrieveData,
  ): CancelablePromise<ApiCandidateProfileRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/candidate-profile/{candidate_id}/",
      path: {
        candidate_id: data.candidateId,
      },
      errors: {
        403: "Access denied - only recruiters, staff, and admins can view candidate profiles",
        404: "Candidate not found or not looking for jobs",
      },
    });
  }
}

export class SearchService {
  /**
   * Search candidates using GET method
   * Alternative GET method for candidate search with query parameters
   * @param data The data for the request.
   * @param data.q Search query
   * @param data.limit Maximum number of results
   * @returns SearchResponse
   * @throws ApiError
   */
  public static apiSearchCandidatesRetrieve(
    data: ApiSearchCandidatesRetrieveData,
  ): CancelablePromise<ApiSearchCandidatesRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/search/candidates/",
      query: {
        limit: data.limit,
        q: data.q,
      },
      errors: {
        400: "Invalid request parameters",
        403: "Access denied",
        500: "Internal server error",
      },
    });
  }

  /**
   * Search candidates using natural language
   *
   * Search for candidates using natural language queries. The system will:
   * - Parse job roles, locations, experience levels, and skills from your query
   * - Search across candidate profiles, experiences, education, and skills
   * - Rank results by relevance using both text search and matching algorithms
   * - Return detailed candidate information with match scores
   *
   * Example queries:
   * - "backend engineer with 5 years experience around DC"
   * - "frontend developer skilled in React and TypeScript"
   * - "data scientist with machine learning experience in San Francisco"
   * - "product manager with startup experience"
   *
   * @param data The data for the request.
   * @param data.query Natural language search query
   * @param data.requestBody
   * @param data.limit Maximum number of results (default: 20, max: 100)
   * @returns SearchResponse
   * @throws ApiError
   */
  public static apiSearchCandidatesCreate(
    data: ApiSearchCandidatesCreateData,
  ): CancelablePromise<ApiSearchCandidatesCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/search/candidates/",
      query: {
        limit: data.limit,
        query: data.query,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Invalid request data",
        403: "Access denied - only recruiters can search candidates",
        500: "Internal server error",
      },
    });
  }

  /**
   * Get search suggestions
   * Get search suggestions based on partial query input
   * @param data The data for the request.
   * @param data.q Partial search query
   * @returns unknown Search suggestions
   * @throws ApiError
   */
  public static apiSearchSuggestionsRetrieve(
    data: ApiSearchSuggestionsRetrieveData,
  ): CancelablePromise<ApiSearchSuggestionsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/search/suggestions/",
      query: {
        q: data.q,
      },
      errors: {
        400: "Invalid request",
        403: "Access denied",
      },
    });
  }
}

export class SuggestionsService {
  /**
   * Get search suggestions
   * Get search suggestions based on partial query input
   * @param data The data for the request.
   * @param data.q Partial search query
   * @returns unknown Search suggestions
   * @throws ApiError
   */
  public static apiSearchSuggestionsRetrieve(
    data: ApiSearchSuggestionsRetrieveData,
  ): CancelablePromise<ApiSearchSuggestionsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/search/suggestions/",
      query: {
        q: data.q,
      },
      errors: {
        400: "Invalid request",
        403: "Access denied",
      },
    });
  }
}

export class UsersService {
  /**
   * Send an email from the authenticated user to any recipient.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Email sent successfully.
   * @throws ApiError
   */
  public static apiSendEmailCreate(
    data: ApiSendEmailCreateData,
  ): CancelablePromise<ApiSendEmailCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/send-email/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Validation error.",
        500: "Failed to send email.",
      },
    });
  }
}

export class CommonService {
  /**
   * Check REST API
   * This endpoint checks if the REST API is working.
   * @returns Message
   * @throws ApiError
   */
  public static commonRestCheckRetrieve(): CancelablePromise<CommonRestCheckRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/common/rest-check/",
    });
  }

  /**
   * API endpoint to get auto-prefill data for application forms.
   * @param data The data for the request.
   * @param data.taskId
   * @returns Message
   * @throws ApiError
   */
  public static commonResumeAutoPrefillRetrieve(
    data: CommonResumeAutoPrefillRetrieveData,
  ): CancelablePromise<CommonResumeAutoPrefillRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/common/resume/auto-prefill/{task_id}/",
      path: {
        task_id: data.taskId,
      },
    });
  }

  /**
   * API endpoint specifically for enhanced resume parsing with auto-prefill data.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Message
   * @throws ApiError
   */
  public static commonResumeEnhancedCreate(
    data: CommonResumeEnhancedCreateData,
  ): CancelablePromise<CommonResumeEnhancedCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/common/resume/enhanced/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * API endpoint to fetch the parsed resume data using the task ID.
   * @param data The data for the request.
   * @param data.taskId
   * @returns Message
   * @throws ApiError
   */
  public static commonResumeResultRetrieve(
    data: CommonResumeResultRetrieveData,
  ): CancelablePromise<CommonResumeResultRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/common/resume/result/{task_id}/",
      path: {
        task_id: data.taskId,
      },
    });
  }
}

export class ResumeService {
  /**
   * Get current user's resume
   * Retrieve the current authenticated user's resume information including URL, filename, and size.
   * @returns unknown Resume information retrieved successfully
   * @throws ApiError
   */
  public static commonResumeUploadRetrieve(): CancelablePromise<CommonResumeUploadRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/common/resume/upload/",
      errors: {
        401: "User not authenticated",
        404: "No resume found for user",
      },
    });
  }

  /**
   * Upload a new resume
   * Upload a new resume file for the authenticated user. The file will be saved and processed asynchronously. Accepts both 'file' and 'resume' field names.
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown Resume uploaded and processing started
   * @throws ApiError
   */
  public static commonResumeUploadCreate(
    data: CommonResumeUploadCreateData = {},
  ): CancelablePromise<CommonResumeUploadCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/common/resume/upload/",
      formData: data.formData,
      mediaType: "multipart/form-data",
      errors: {
        400: "No file uploaded",
        401: "User not authenticated",
      },
    });
  }

  /**
   * Replace resume file
   * Replace the entire resume file for the authenticated user (idempotent operation). The old file will be deleted before saving the new one. Accepts both 'file' and 'resume' field names.
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown Resume replaced and processing started
   * @throws ApiError
   */
  public static commonResumeUploadUpdate(
    data: CommonResumeUploadUpdateData = {},
  ): CancelablePromise<CommonResumeUploadUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/common/resume/upload/",
      formData: data.formData,
      mediaType: "multipart/form-data",
      errors: {
        400: "No file uploaded",
        401: "User not authenticated",
      },
    });
  }

  /**
   * Delete resume
   * Remove the resume file from the authenticated user's profile. The file will be deleted from storage and the resume field will be cleared.
   * @returns unknown Resume deleted successfully
   * @throws ApiError
   */
  public static commonResumeUploadDestroy(): CancelablePromise<CommonResumeUploadDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/common/resume/upload/",
      errors: {
        401: "User not authenticated",
        404: "No resume found for user",
      },
    });
  }
}
